import ApiClient from "services/ApiClient";
import qs from "qs";

import { formatSortField } from "utils/FormatUtils";

const PAGE_SIZE = 10;

class DashboardService extends ApiClient {
  getDashboardResources({ page = 1, pageSize = PAGE_SIZE, sortBy, searchFilter }) {
    const query = {
      page,
      pageSize,
    };

    if (sortBy && sortBy.field && sortBy.direction !== "None") {
      query.SortFieldName = formatSortField(sortBy.field);
      query.SortDirection = sortBy.direction;
    }

    if (searchFilter) {
      query.Name = searchFilter;
    }

    return this.call({
      method: "get",
      url: `/dashboard/assignments?${qs.stringify(query)}`,
    });
  }

  getDashboardREResources({ page = 1, pageSize = PAGE_SIZE, sortBy, searchFilter }) {
    const query = {
      page,
      pageSize,
    };

    if (sortBy && sortBy.field && sortBy.direction !== "None") {
      query.SortFieldName = formatSortField(sortBy.field);
      query.SortDirection = sortBy.direction;
    }

    if (searchFilter) {
      query.Name = searchFilter;
    }

    return this.call({
      method: "get",
      url: `/dashboard/assignments/risk-engineer?${qs.stringify(query)}`,
    });
  }

  updateInspectionDate(data) {
    return this.call({
      method: "put",
      url: "/assignments/inspection-date",
      data,
    });
  }
}

export default new DashboardService();
